import { globalConfig } from '../../configuration/config'

type APIUtilsReturnType = () => {
  get: <T>(apiUrl: string) => Promise<T>
  makeAPICall: <T>(apiUrl: string, type: string, body?: string) => Promise<T>
}

export enum APICallType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export const ErrorMessageForDuplicatePatientEntry = 'Duplicate Data'

export enum APIBaseURL {
  SCHEDULING = 'https://app-P2P-devapi.azurewebsites.net',
  COMMUNICATION = 'https://app-P2P-devapi.azurewebsites.net',
}

const setupHeaders = async () => {
  const encryptedToken = sessionStorage.getItem('encryptedToken') || ''
  const encryptedAESKey = sessionStorage.getItem('encryptedAESKey') || ''

  console.log(' Setup Headers Debug:')
  console.log(
    '  - Has encryptedToken:',
    !!encryptedToken,
    encryptedToken ? `(${encryptedToken.substring(0, 20)}...)` : '(EMPTY)'
  )
  console.log(
    '  - Has encryptedAESKey:',
    !!encryptedAESKey,
    encryptedAESKey ? `(${encryptedAESKey.substring(0, 20)}...)` : '(EMPTY)'
  )

  return {
    'Content-Type': 'application/json',
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
    EncryptedAESKey: encryptedAESKey,
    EncryptedToken: encryptedToken,
  }
}

const APIUtils: APIUtilsReturnType = () => {
  const globalConfigData = globalConfig.get()
  const baseUrl = globalConfigData.apiBaseUrl

  console.log(' API Utils Debug:')
  console.log('  - Current Domain:', window.location.host)
  console.log('  - API Base URL:', baseUrl)

  async function get<T>(apiUrl: string): Promise<T> {
    const headers = await setupHeaders()
    const fullUrl = baseUrl + apiUrl

    console.log(' GET Request:')
    console.log('  - URL:', fullUrl)

    const request = {
      method: APICallType.GET,
      headers,
    }
    return fetch(fullUrl, request)
      .then((response) => {
        console.log(' GET Response:', {
          url: fullUrl,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        })

        if (response.ok) {
          return response.json()
        }
        console.error(' GET Request Failed:', response)
        return response
      })
      .then((data) => {
        console.log(' GET Data received:', data)
        return data as T
      })
      .catch((error) => {
        console.error(' GET Request Error:', error)
        throw error
      })
  }

  async function makeAPICall<T>(
    apiUrl: string,
    type: string,
    body?: string
  ): Promise<T> {
    const headers = await setupHeaders()
    const fullUrl = baseUrl + apiUrl

    console.log(` ${type} Request:`)
    console.log('  - URL:', fullUrl)
    console.log('  - Body:', body)

    const request = {
      method: type,
      body: body || null,
      headers,
    }
    return fetch(fullUrl, request)
      .then((response) => {
        console.log(` ${type} Response:`, {
          url: fullUrl,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        })

        if (response.status === 204) {
          return { success: true }
        }
        if (response.ok) {
          return response.json()
        } else {
          console.error(` ${type} Request Failed:`, response)
          if (response.status === 409) {
            throw new Error(ErrorMessageForDuplicatePatientEntry)
          } else {
            return response.text().then((text) => {
              console.error(` Error Response Text:`, text)
              throw new Error(text)
            })
          }
        }
      })
      .then((data) => {
        console.log(` ${type} Data received:`, data)
        return data as T
      })
      .catch((error) => {
        console.error(` ${type} Request Error:`, error)
        throw error
      })
  }

  return {
    get,
    makeAPICall,
  }
}

export default APIUtils
